import React, { useMemo } from 'react';

/**Utils */
import { getValueFromObjectWithString } from '../functions/General';
import useWindowDimensions from '../../../helpers/useWindowDimensions';

const INACTIVE_DAYS_LIMIT = 2;

/** fix the top position apparently cus the perfectScroll component  */

export const RequestDaysTableCell = ({ row, comparativeDateField }) => {
    const { /*height,*/ width } = useWindowDimensions();

    const inactivesDays = useMemo(
        () =>
            Math.round(
                (new Date().getTime() -
                    new Date(
                        getValueFromObjectWithString(
                            row.original,
                            comparativeDateField
                        )
                    ).getTime()) /
                    (1000 * 3600 * 24)
            ),
        [row.original, comparativeDateField]
    );

    if (inactivesDays >= INACTIVE_DAYS_LIMIT) {
        return (
            <div className={`text-danger ${width <= 991 ? '' : 'text-center'}`}>
                <span className="" style={{ justifyContent: 'space-evenly' }}>
                    <b>{`${inactivesDays} días`} </b>
                </span>
            </div>
        );
    } else {
        return (
            <div className={`${width <= 991 ? '' : 'text-center'}`}>
                <span className="">{`${inactivesDays} días`}</span>
            </div>
        );
    }
};
